function addClass(el, className) {
  const classes = (className || '').split(' ')

  classes.forEach((c) => {
    el.classList.remove(c)
    el.classList.add(c)
  })
}

function removeClass(el, className) {
  const classes = (className || '').split(' ')

  classes.forEach((c) => {
    el.classList.remove(c)
  })
}

function removeElement(element) {
  if (element && element.parentNode) {
    element.parentNode.removeChild(element)
  }
}

function outerHeight(el) {
  let elHeight = el.offsetHeight
  const style = window.getComputedStyle(el)

  elHeight += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10)

  return elHeight
}

function outerWidth(el) {
  let elWidth = el.offsetWidth
  const style = window.getComputedStyle(el)

  elWidth += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10)

  return elWidth
}

function height(el) {
  return parseFloat(getComputedStyle(el, null).height.replace('px', ''))
}

function width(el) {
  return parseFloat(getComputedStyle(el, null).width.replace('px', ''))
}

function offset(el) {
  const rect = el.getBoundingClientRect()

  return {
    top: rect.top + document.body.scrollTop,
    left: rect.left + document.body.scrollLeft,
  }
}

function offsetFromPage(el) {
  const rect = el.getBoundingClientRect()

  return {
    top: rect.top + window.scrollY,
    left: rect.left + window.scrollX,
  }
}

function position(el) {
  return {
    left: el.offsetLeft,
    top: el.offsetTop,
  }
}

function onDOMReady(callback) {
  if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
  ) {
    callback()
  } else {
    document.addEventListener('DOMContentLoaded', callback)
  }
}

export default {
  addClass,
  removeClass,
  removeElement,
  outerHeight,
  outerWidth,
  height,
  width,
  offset,
  offsetFromPage,
  position,
  onDOMReady,
}



// WEBPACK FOOTER //
// ./src/utils/domUtils.js